/* =====================================================================
   The interest notice — open, close, and the browser's back button.

   Three ways in and three ways out, all landing on the same two calls, so
   the page can never end up half-open: the lock on the body, the hidden
   attribute and the history entry are always changed together.

   The history entry is the point of care. Opening pushes #interest, so the
   view is linkable and the back gesture closes it rather than leaving the
   product sheet. Closing by hand therefore has to spend that entry with
   history.back() instead of pushing a second one — otherwise every open
   and close would stack another step the visitor has to walk back through.
   ===================================================================== */
(function () {
  var view = document.getElementById('interest-notice');
  if (!view) return;

  var opener = null;
  var open = false;

  function show(pushHash) {
    if (open) return;
    open = true;
    opener = document.activeElement;
    view.hidden = false;
    /* the hidden attribute has to be off for a frame before the class
       lands, or the transition has nothing to transition from */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        view.classList.add('is-open');
        /* only now. Until the class lands the view is visibility:hidden,
           and nothing inside a visibility:hidden box can take focus — call
           focus() before this and it silently does nothing, leaving the
           keyboard on the body with a dialog open in front of it. */
        var out = view.querySelector('[data-inq-close]');
        if (out) out.focus({ preventScroll: true });
      });
    });
    document.body.classList.add('inq-lock');
    if (pushHash && history.pushState) {
      history.pushState({ inq: 1 }, '', '#interest');
    }
  }

  function hide() {
    if (!open) return;
    open = false;
    view.classList.remove('is-open');
    document.body.classList.remove('inq-lock');
    /* kept in the tree until the cross-fade is spent, then taken out of it
       entirely — a fixed pane at opacity 0 still swallows clicks */
    window.setTimeout(function () { if (!open) view.hidden = true; }, 520);
    if (opener && opener.focus) opener.focus({ preventScroll: true });
    opener = null;
  }

  function dismiss() {
    if (!open) return;
    if (history.state && history.state.inq) history.back();   /* spends the entry */
    else hide();
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-interest-open]'), function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); show(true); });
  });
  Array.prototype.forEach.call(view.querySelectorAll('[data-inq-close]'), function (btn) {
    btn.addEventListener('click', dismiss);
  });

  document.addEventListener('keydown', function (e) {
    if (open && (e.key === 'Escape' || e.key === 'Esc')) dismiss();
  });

  window.addEventListener('popstate', function () {
    if (open) hide();
    else if (location.hash === '#interest') show(false);
  });

  /* arriving on the link with the view already named */
  if (location.hash === '#interest') show(false);
})();
